<template>
  <div class="flex">
    <filter-field-default
        label="comm type"
        v-model="directionFilter"
    >
      <option
          v-for="direction in directions"
          :key="direction.value"
          :value="direction.value"
      >{{ direction.label }}</option>
    </filter-field-default>
<!-- This button isn't necessary with only one filter, but I'll leave it hear in case we add more -->
<!--    <filter-button-clear @click="clearFilter"></filter-button-clear>-->
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";

export default {
  name: 'CommsFilters',
  data() {
    return {
      commsIsLoading: false
    }
  },
  computed: {
    commsFilters() {
      return this.$store.state.comms.filters.comms;
    },
    directionFilter: {
      get() { return this.commsFilters.custom },
      set(val) { this.$store.commit('comms/setOneFilter', ['comms', 'custom', val])}
    },
    directions() {
      const directions = Object.entries(ENUMS.CommunicationDirectionEnum).map(([key, data]) => {
        return { value: data.value, label: data.label }
      });

      return [
        { value: 0, label: 'All' },
        ...directions,
        { value: 3, label: 'Unaddressed Inbound' },
      ];
    },
  },
  methods: {
    clearFilter() {
      this.$store.commit('comms/resetCommsFilters');
    }
  }
}
</script>
